module.exports = __webpack_public_path__ + "img/payment.51510d3f.svg";